import { CommonModule, DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { DataTableService } from '../../../core/services/data-table.service';
import { TableActionDirective } from '../../../shared/components/table/table-action.directive';
import { TableCellDirective } from '../../../shared/components/table/table-cell.directive';
import { TableComponent } from '../../../shared/components/table/table.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SideBarDoubleComponent } from '../../../shared/components/side-bar-double/side-bar-double.component';
import { FilterIndicatorsBarComponent } from '../register/filter-indicators-bar/filter-indicators-bar.component';
import { RegisterHeaderComponent } from '../register/register-header/register-header.component';
import { IndexListValueService } from '../../apiModule1';
import { IndexListValueTableService } from './columns-index.service';
import { CURRENT_ENTITY_TOKEN, DataService, IndexEntityComponent } from '../index-entity/index-entity.component';
import { CapitalizePipe } from '../../../core/pipes/capitalize.pipe';
import { DialogComponent } from './dialog/dialog.component';
import { FilterDialogComponent } from './filter-dialog/filter-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { CommunicationService } from '../../../core/services/communication.service';
import { take } from 'rxjs';
export interface ImportIndexListValueFileError {
    errorMessage: string;
    lineNumber: number;
}

export interface ImportIndexListValueFileErrorLog {
    errorCount: number;
    newImportedCount: number;
    updatedCount: number;
    errors: ImportIndexListValueFileError[];
}

export function isImportIndexListValueFileErrorLog(v: any): v is ImportIndexListValueFileErrorLog {
    return v && typeof v === 'object' && 'errorCount' in v && 'newImportedCount' in v && 'updatedCount' in v && 'errors' in v;
}

@Component({
    selector: 'pas-index-list-value',
    standalone: true,
    imports: [
        CommonModule,
        TableComponent,
        TableCellDirective,
        TableActionDirective,
        MatIcon,
        MatIconButton,
        MatMenu,
        MatMenuTrigger,
        RegisterHeaderComponent,
        MatSidenavModule,
        MatDatepickerModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        SideBarDoubleComponent,
        DatePipe,
        FilterIndicatorsBarComponent,
        CapitalizePipe,
        MatProgressSpinnerModule
    ],
    templateUrl: '../index-entity/index-entity.component.html',
    styleUrls: ['../index-entity/index-entity.component.scss'],
    providers: [
        { provide: DataTableService, useClass: IndexListValueTableService },
        { provide: CURRENT_ENTITY_TOKEN, useValue: 'index-list-value' },
        { provide: DataService, useClass: IndexListValueService },
    ]
})
export class IndexListValueComponent extends IndexEntityComponent {
    private http = inject(HttpClient);
    private toastsService = inject(CommunicationService);
    protected override dialogComponent = DialogComponent;
    protected override filterDialogComponent = FilterDialogComponent;

    constructor(
        public override dataTableService: DataTableService,
        @Inject(DataService) public override dataService: any,
        @Inject(CURRENT_ENTITY_TOKEN) public override currentEntity: string) {
        super(dataTableService, dataService, currentEntity);
    }

    override onFileDownload(event: Event) {
        this.isFinishedDownloadExcel.set(true);

        const FILE_DOWNLOAD_URL = '/api/indexlistvalue/loadexcel';
        const target = event.target as HTMLInputElement;

        if (!target || !target.files || !target.files.length) {
            this.isFinishedDownloadExcel.set(false);
            return;
        }

        const selectedFile = target.files[0];

        const fd = new FormData();
        fd.append('file', selectedFile);

        this.http.post(environment.api_url + FILE_DOWNLOAD_URL, fd)
            .pipe(take(1))
            .subscribe({
                next: (v: any) => {
                    this.isFinishedDownloadExcel.set(false);
                    this.toastsService.sucess('Файл загружен');
                    isImportIndexListValueFileErrorLog(v) && this._createLogFile(v);
                    this.getData();
                },
                error: (e: any) => {
                    this.isFinishedDownloadExcel.set(false);
                    this.toastsService.error(e.errors?.[0]?.errorMessage || 'Файл не загружен');
                }
            });
    }

    private _createLogFile(v: ImportIndexListValueFileErrorLog): void {
        const file = JSON.stringify(v);
        const blob = new Blob([file], { type: 'application/json' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'import_index_list_value_error_log.json';
        link.click();
        window.URL.revokeObjectURL(url);
    }
}
